var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDessertsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.7317 9.5808V23.203H1V9.5808M31.7317 9.5808H13.4235V16.8823C13.4238 17.1922 13.3612 17.499 13.2394 17.784C13.1177 18.069 12.9393 18.3263 12.7151 18.5403C12.4909 18.7543 12.2256 18.9206 11.9352 19.0289C11.6449 19.1373 11.3355 19.1856 11.0259 19.1708H10.917C10.31 19.1708 9.72792 18.9297 9.29873 18.5006C8.86955 18.0714 8.62844 17.4893 8.62844 16.8823V9.5808H1M31.7317 9.5808L16.0389 2.17051C13.8577 1.06218 11.3646 0.728125 8.96859 1.22317C6.57258 1.71821 4.41597 3.01296 2.85262 4.89495C1.75698 6.22287 1.10861 7.86265 1 9.5808M1 16.4469H4.16035M17.6736 16.4469H31.7317",
    stroke: "white",
    strokeWidth: 1.22361,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDessertsActive);
export default __webpack_public_path__ + "static/media/ic-desserts-active.24904fc86ac86c2312abf273e79d969b.svg";
export { ForwardRef as ReactComponent };